import React from 'react';
import { Box, Typography, TextField, Button, Paper } from '@mui/material';
import FinalizeArgumentButton from './FinalizeArgumentButton';

interface ArgumentInputProps {
  userInput: string;
  setUserInput: (value: string) => void;
  handleUserInputSubmit: () => void;
  handleFinalizeArgument: () => void;
  loading: boolean;
  hasReceivedResponse: boolean;
  isFinalized: boolean;
}

const ArgumentInput: React.FC<ArgumentInputProps> = ({
  userInput,
  setUserInput,
  handleUserInputSubmit,
  handleFinalizeArgument,
  loading,
  hasReceivedResponse,
  isFinalized,
}) => {
  // If the argument is finalized, we hide the entire input section
  if (isFinalized) return null;

  // Determine whether our "Add" button should be disabled
  const isAddDisabled = loading || !userInput.trim() || isFinalized;

  return (
    <>
      <Paper 
        elevation={2}
        sx={{ 
          p: 3,
          maxWidth: 600,
          mx: 'auto',
          textAlign: 'left',
        }}
      >
      <Typography variant="h3" gutterBottom>
        Explain your side of the argument
      </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <TextField
            multiline
            rows={4}
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
            placeholder="From my perspective..."
            fullWidth
            variant="outlined"
            sx={{maxWidth: 600}}
          />
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
            <Button
              onClick={handleUserInputSubmit}
              disabled={isAddDisabled}
              variant="contained"
              color="primary"
            >
              {loading ? 'Submitting...' : 'Add to Argument'}
            </Button>
            <FinalizeArgumentButton
              handleFinalizeArgument={handleFinalizeArgument}
              hasReceivedResponse={hasReceivedResponse}
              isFinalized={isFinalized}
              userInput={userInput}
            />
          </Box>
        </Box>
      </Paper>
    </>
  );
};

export default ArgumentInput;
